export default __webpack_public_path__ + "static/media/1.a5a9045c.jpg";